@if (securityService.meSignal()!) {
    <mat-toolbar>
        <a
            class="cursor-pointer"
            id="logo"
            (click)="onLogoClick($event)">
            <img
                alt="ConnectServices logo"
                fetchpriority="high"
                height="36"
                ngSrc="assets/images/logo/connect_services_logo_black.png"
                width="140" />
        </a>
        <div class="pl-6 flex grow">
            <app-project-select class="w-96" />
        </div>
        <div class="flex flex-wrap justify-end items-center gap-6">
            <span class="gap-4">
                <app-data-button />
                <app-organization />
            </span>

            <app-profile-icon />
        </div>
    </mat-toolbar>
}
